/**
 * 文章请求模块
 */
import request from '../utils/request'

export const createLead = data => {
  return request({
    method: 'POST',
    url: '/api/v1/fusionops/crm-leadz/anonymous_create',
    data
  })
}

export const getLandingPage = campaignid => {
  return request({
    method: 'GET',
    url: `/api/v1/fusionops/crm-landing-pages/campaign/${campaignid}`
  })
}

export const getBrand = param => {
  return request({
    method: 'GET',
    url: '/api/v1/fusionops/crm-brands/brandtree',
    params: param
  })
}

export const getArea = param => {
  return request({
    method: 'GET',
    url: '/api/v1/fusionops/crm-areas/citytree',
    params: param
  })
}

export const getDealer = data => {
  return request({
    method: 'GET',
    url: '/api/v1/fusionops/crm-daelers/query',
    params: data
  })
}
